import React from "react";
import Imagen_pe from "../../../../new_images/Landing/Photos_Top/Photos_top_medio_ambiente_apoyo.png";
import "./Ambiente.css";

class HazTuCamino extends React.Component {
  render() {
    return (
      <div id="apppage">
        <section>
          <div id="somos" className="row ce_container row-cols-1 row-cols-md-2">
            <div className="col-lg-5 col-md-12 col-sm-12">
              <img
                src={Imagen_pe}
                object-fit="width"
                width="100%"
                alt="logo"
              />
            </div>
            <div className="col-lg-6">
              <p className="pe_title">Apoya al Medio Ambiente</p>
              <p className="pe_subtitle">
                Tu ayuda es clave para reducir la emisión de C02
              </p>
              <p className="pe_body">
                Ser un conductor de Tovo te permite colaborar con el medio ambiente sin dejar la cotidianidad de tu vida.  
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HazTuCamino;
